var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function ProposalGeneralFill(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0209 3 20.55 3 20V15.45L5.75 12.325L7.175 13.75L5.175 16H18.825L16.875 13.8L18.3 12.375L21 15.45V20C21 20.55 20.8042 21.0209 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM10.6 14.4L7.125 10.875C6.74167 10.4917 6.55 10.0167 6.55 9.45005C6.55 8.88338 6.74167 8.40838 7.125 8.02505L12.025 3.12505C12.4083 2.74172 12.8833 2.55005 13.45 2.55005C14.0167 2.55005 14.4917 2.74172 14.875 3.12505L18.4 6.60005C18.7833 6.98338 18.9792 7.45422 18.9875 8.01255C18.9958 8.57088 18.8083 9.04172 18.425 9.42505L13.425 14.425C13.0417 14.8084 12.5708 14.9959 12.0125 14.9875C11.4542 14.9792 10.9833 14.7834 10.6 14.4ZM17 8.00005L13.45 4.50005L8.5 9.45005L12.05 12.95L17 8.00005Z", fill: color }) })));
}
